import { render } from "./ServiceGridComp.vue?vue&type=template&id=3ccae863&scoped=true"
import script from "./ServiceGridComp.vue?vue&type=script&lang=js"
export * from "./ServiceGridComp.vue?vue&type=script&lang=js"

import "./ServiceGridComp.vue?vue&type=style&index=0&id=3ccae863&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ccae863"]])

export default __exports__